import { render, staticRenderFns } from "./CourseraHeader.vue?vue&type=template&id=add86ec2&scoped=true&"
import script from "./CourseraHeader.vue?vue&type=script&lang=ts&"
export * from "./CourseraHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CourseraHeader.vue?vue&type=style&index=0&id=add86ec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add86ec2",
  null
  
)

export default component.exports